import React from "react";
import { Box } from "@mui/material";

const RefundFailedReceipt = ({ orderReport, formatpaymentTime, failedImg }) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];

  if (refundInfo?.status !== "REFUND_FAILED") return null;

  const hrStyle = {
    marginTop: "2vw",
    marginBottom: "2vw",
    borderColor: "#E0E0E0",
    borderWidth: "0.5px"
  };

  return (
    <div style={{ marginTop: "5vw" }}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
   {/*      <Box
          component="img"
          src={failedImg}
          alt="Refund Initiation Failed"
          sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
        /> */}
                <img src={failedImg} style={{width:"68px",height:"68px",borderRadius:"2px",maxHeight:155}}/>

      </Box>

      <h1
        style={{
          color: "#C20C0C",
          fontSize: "20px",
          fontWeight: "600",
          textAlign: "center",
          marginTop: "2vw"
        }}
      >
        Refund Failed
      </h1>

      <div className="refund-box" style={{ padding: "0px 5px 10px 5px" }}>
        <p style={{ fontWeight: 400, fontSize: "12px", fontFamily: "Poppins" }}>
          Refund could not be processed due to a technical issue. Failure Reference Number is{" "}
          {refundInfo?.transactionId}
        </p>
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Amount to be Refunded:</span> ₹ {refundInfo?.refundAmount}
        </p>
        <hr style={hrStyle} />
        <p className="text-xs text-gray-600 mt-1" style={{ fontSize: "10px" }}>
          Expected Settlement Time: Refund processing (refund schedule time + 60 minutes)
        </p>
      </div>

      <div className="rounded-lg p-3 mb-4" style={{ paddingTop: 0 }}>
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Order:</span> {items.length} Items
        </p>
        <hr style={hrStyle} />

        <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs">
          <div style={{ textAlign: "start" }}>Item(Count)</div>
          <div>Price/Unit</div>
          <div style={{ marginRight: "2vw" }}>Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800"
            style={{ fontSize: "10px" }}
          >
            <div style={{ textAlign: "start" }}>
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName}{" "}
              ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="text-red-500 font-medium">
              {item.successQuantity > 0 && (
                <span
                  style={{
                    color: "#000000B2",
                    fontSize: "10px",
                    fontWeight: "700",
                    fontFamily: "Roboto"
                  }}
                >
                  Success({item.successQuantity})
                </span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span
                  style={{
                    color: "#E65C5C",
                    fontSize: "10px",
                    fontWeight: "700",
                    fontFamily: "Roboto"
                  }}
                >
                  Failed({item.failureQuantity})
                </span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span
                  style={{
                    color: "#F28618",
                    fontSize: "10px",
                    fontWeight: "700",
                    fontFamily: "Roboto"
                  }}
                >
                  Pending({item.vendRemaining})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3" style={{ paddingTop: 0 }}>
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Paid Amount:</span> ₹ {refundInfo?.paidAmount}
        </p>
        <hr style={hrStyle} />
        <p className="text-xs" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          {formatpaymentTime}
        </p>
        <p className="text-xs" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          Transaction ID: {refundInfo?.transactionId}
        </p>
        <p className="text-xs mt-2" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          Payment Method: <span className="font-medium">{refundInfo?.payMethod}</span>
        </p>
      </div>

      <div style={{padding:".75rem"}}><hr style={hrStyle} /></div>
    </div>
  );
};

export default RefundFailedReceipt;
